import {useQueryString} from 'hooks'
import _ from 'lodash'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useCallback, useEffect, useState} from 'react'
import {NullAsDefault} from 'views/Shared'
import {Queries} from '../enums/Queries'
import {useRouteSearchParam} from "../../../envs/_current/history";
import LoadingBlock from "../../LoadingBlock";

export const useMenuHandler = ({
                                   isLoading = false,
                                   actionName = Queries.REL,
                                   routes = [
                                       {
                                           key: undefined,
                                           component: NullAsDefault,
                                       },
                                   ],
                               }) => {
    const currentAction = useRouteSearchParam(actionName)

    const {key: defaultActiveKey} = _.first(routes) || {
        key: undefined,
    }

    const history = useHistory()

    const pathname = _.get(history, 'location.pathname')

    const [queryString] = useQueryString(pathname)

    const searchParams = _.omit(queryString, [actionName])

    const [activeKey, setActivekey] = useState(defaultActiveKey)

    const Component = useCallback(
        (props) => {
            const {component: C = NullAsDefault} =
            _.find(routes, {
                key: activeKey,
            }) || {}
            return !!isLoading ? <LoadingBlock/> : <C {...props} />
        },
        [activeKey, isLoading]
    )

    const onMenuSelect = (key) => {
        history.push({
            search: [
                '?',
                new URLSearchParams({
                    [actionName]: key,
                    // ...searchParams,
                }).toString(),
            ].join(''),
        })
    }

    useEffect(() => {
        if (
            !!isLoading ||
            _.find(routes, {
                key: currentAction,
            })
        ) {
            setActivekey(currentAction)
        } else if (!_.isEmpty(currentAction)) {
            history.push({
                search: '',
            })
        }
    }, [isLoading, currentAction])

    return {
        activeKey,
        actionName,
        Component,
        onMenuSelect,
        currentAction,
    }
}
